<template>
  <v-container class="bottom">
    <v-layout row>
      <v-flex class="containerBanner" md10 lg10 xs12 sm11 xl10>
        <img :src="img1" style="width:100%;" />
      </v-flex>
    </v-layout>
    <v-layout row>
      <div>
        <v-snackbar
          class="new-alert"
          v-model="alert"
          :timeout="timeout"
          :color="alertType"
          top="top"
        >
          {{this.alertMessage}}
          <v-icon color="white" flat @click="alert = false">close</v-icon>
        </v-snackbar>
      </div>
      <v-flex offset-xs0 offset-md1 offset-lg0 offset-sm0 offset-xl0 md9 lg10 xs12 sm11 xl10>
        <v-flex class="containerStyle2" md12 lg12 xs12 sm12>
          <v-layout row>
            <v-flex md12 lg12 xs12 sm12>
              <h2 class="titlep">Objetivos de desarrollo sostenible - Líneas Emergentes</h2>
              <v-layout align-center justify-center>
                <v-flex md9 lg9 xs9 sm9 xl9>
                  <p
                    class="text-mision"
                  >Para realizar un mapeo de la contribución a los ODS, en cada línea de trabajo, señale a qué objetivo impacta, ya sea directa y/o indirectamente.</p>
                  <ul class="padding">
                    <li
                      class="text-mision"
                    >Para señalar un objetivo que considere que es impactado directamente por la línea de trabajo, marque la opción “Directo” y luego haga clic en la matriz.</li>
                    <li
                      class="text-mision"
                    >Para señalar a qué objetivos se impacta indirectamente, marque la opción “indirecto” y luego haga clic en la matriz.</li>
                    <li
                      class="text-mision"
                    >Para identificar las líneas de trabajo, posicione el puntero en cada línea y podrá visualizar el nombre de la línea de trabajo correspondiente.</li>
                  </ul>
                </v-flex>
              </v-layout>
              <v-radio-group
                v-if="this.$session.getAll().permiso"
                class="justify-center marginnull"
                row
                v-model="seleccion"
              >
                <v-radio color="#63cb67" :key="1" :value="1">
                  <template v-slot:label>
                    <div>Directo</div>
                  </template>
                </v-radio>
                <v-radio color="#4878c0" :key="2" :value="2">
                  <template v-slot:label>
                    <div>Indirecto</div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-flex>
          </v-layout>
          <v-layout row>
            <v-flex md12 lg12 xs12 sm12>
              <table id="secondTable" class="table">
                <thead>
                  <tr>
                    <th>Objetivo de desarrollo sostenible</th>
                    <th v-for="(col,index) in headers" :key="index">
                      <v-tooltip top>
                        <template v-slot:activator="{ on }">
                          <span v-on="on">Linea {{index + 1}}</span>
                        </template>
                        <span>{{col.nombre}}</span>
                      </v-tooltip>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  <tr v-for="(row,indexCol) in columns" :key="indexCol">
                    <td v-show="indexCol != 0">{{headers2[indexCol]}}</td>
                    <td
                      :class="claseElegida"
                      v-show="indexCol != 0"
                      @click="selecciona(col, String(indexCol)+ '-' + String(indexRow), indexRow, indexCol)"
                      :id="String(indexCol) + '-' +String(indexRow) "
                      v-for="(col,indexRow) in rows "
                      :key="indexRow"
                    ></td>
                  </tr>
                </tbody>
              </table>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-btn
              v-if="this.$session.getAll().permiso"
              color="#EB7704"
              @click="saveODS()"
            >Guardar cambios</v-btn>
            <v-layout align-center justify-end>
              <v-btn color="#EB7704" :to="{name: 'odsActual'}">Volver a Líneas Actuales</v-btn>
            </v-layout>
          </v-layout>
          <br />

        </v-flex>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import img1 from "../../assets/BANNER_2.png";
import img3 from "../../assets/nuevaasistenciadca.png";

export default {
  data() {
    return {
      ccValor: "",
      img3: img3,
      img1: img1,
      seleccion: 1,
      headers: [],
      headers2: [
        "0.- Dummy",
        "1.- Fin de la pobreza",
        "2.- Hambre cero",
        "3.- Salud y bienestar",
        "4.- Educación de calidad",
        "5.- Igualdad de género",
        "6.- Agua limpia y saneamiento",
        "7.- Producción y consumo responsables",
        "8.- Acción por el agua",
        "9.- Vida submarina",
        "10.- Vida de ecosistemas terrestres",
        "11.- Energía asequible y no contaminante",
        "12.- Trabajo decente y crecimiento económico",
        "13.- Industria, innovación e infraestructura",
        "14.- Reducción de las desigualdades",
        "15.- Ciudades y comunidades sostenibles",
        "16.- Paz, justicia e instituciones sólidas",
        "17.- Alianzas para lograr los objetivos"
      ],
      rows: [],
      selected: [],
      timeout: 4000,
      alertType: "success",
      alertMessage: "",
      alert: false,
      create: false,
      edit: false,
      index: "",
      claseElegida: "new1",
      typeEstrategico: "1",
      auth: {
        headers: { Authorization: "" + this.$session.get("jwt") }
      }
    };
  },

  computed: {
    columns: function columns() {
      if (this.rows.length == 0) {
        return [];
      }
      //console.log("qui van las rows que no se que es");
      //console.log(this.rows[0]);
      return Object.keys(this.rows[0]);
    }
  },

  watch: {
    seleccion: function() {
      this.changeClass();
    }
  },
  created() {
    this.ccValor = this.$session.getAll().ccData.ccValor;
    //TODO: ver que renderizar si x alguna razón hay error
    axios
      .get(
        process.env.ROOT_API +
          "/investigacionConsolidado/odsInvestigacionesFuturas?ccValor=" +
          this.ccValor,
        this.auth
      )
      .then(response => {
        this.rows = response.data;
        //console.log(this.rows);
      })
      .catch(error => {
        console.error(error);
        this.showAlert("error", error);
      })
      .then(response => {
        axios
          .get(
            process.env.ROOT_API +
              "/investigacionConsolidado/getHeaderFuturos?ccValor=" +
              this.ccValor,
            this.auth
          )
          .then(response => {
            this.headers = response.data;
            //console.log(this.headers);
          })
          .catch(error => {
            console.error(error);
            this.showAlert("error", error);
          });
      })
      .then(response => {
        //console.log("mounted");
        var i;
        for (i = 0; i < this.rows.length; i++) {
          var j;
          for (j = 1; j <= 17; j++) {
            //console.log(this.rows[i]);
            this.pinta(this.rows[i], String(j) + "-" + String(i), j);
          }
        }
      });
  },
  methods: {
    changeClass() {
      this.claseElegida = "new" + this.seleccion;
    },
    saveODS() {
      //console.log("SAVEEEEEEEEEEEEE");
      //console.log(this.rows);
      axios
        .put(
          process.env.ROOT_API + "/investigacionConsolidado/updateODS",
          this.rows,
          this.auth
        )
        .then(response => {
          //console.log(response.data);
          this.showAlert(
            "success",
            "Matriz de Objetivos de desarrollo sostenible guardada"
          );
        })
        .catch(error => {
          console.error(error);
          this.showAlert("error", error);
        });
    },

    showAlert(type, message) {
      this.alertType = type;
      this.alertMessage = message;
      this.alert = true;
    },

    pinta(linea, index, indexcol) {
      //console.log("entre al pinta");
      //console.log(linea);
      if (linea["ODS" + String(indexcol)] === 1) {
        document.getElementById(index).style.backgroundColor = "#63cb67";
      }
      if (linea["ODS" + String(indexcol)] === 2) {
        document.getElementById(index).style.backgroundColor = "#4878c0";
      }
    },

    selecciona(linea, index, indexcol, indexRow) {
      //console.log(linea);
      //console.log(index);
      //console.log(indexcol);
      //console.log(indexRow);
      if (indexRow != "0") {
        if (
          linea["ODS" + String(indexRow)] === 1 ||
          linea["ODS" + String(indexRow)] === 2
        ) {
          //console.log("selecciona");
          document.getElementById(index).style.backgroundColor = "white";
          linea["ODS" + String(indexRow)] = 0;
          //console.log(this.rows[indexRow])
          this.rows[indexcol] = linea;
        } else {
          if (this.seleccion === 1) {
            linea["ODS" + String(indexRow)] = 1;
            //console.log(this.rows[indexRow])
            this.rows[indexcol] = linea;
            document.getElementById(index).style.backgroundColor = "#63cb67";

            //console.log("Red");
          } else {
            linea["ODS" + String(indexRow)] = 2;
            //console.log(this.rows[indexRow])
            this.rows[indexcol] = linea;
            document.getElementById(index).style.backgroundColor = "#4878c0";
          }
        }

        //console.log("van las Rows meris");
        //console.log(this.rows);
      }
    }
  }
};
</script>


<style scoped>
.new-alert {
  z-index: 9000;
  width: auto;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
}

.new-alert .theme--light.v-icon {
  color: #ffffff !important;
}
.containerBanner {
  width: 100%;
  margin-top: 50px !important;
}
.marginnull {
  margin-bottom: 0;
  margin-top: 0;
  padding: 0;
}
.tooltip {
  text-align: center;
}
table {
  font-family: "Open Sans", sans-serif;
  border-collapse: collapse;
  border: 1px solid #e47215;
  margin: 5px 5px 0 5px;
  border-radius: 20%;
}
.new1:hover {
  background-color: #63cb67;
  cursor: pointer;
  -webkit-transition: background-color 0.5s ease-out;
  -moz-transition: background-color 0.5s ease-out;
  -o-transition: background-color 0.5s ease-out;
  transition: background-color 0.5s ease-out;
}

.new2:hover {
  background-color: rgb(72, 120, 192);
  cursor: pointer;
  -webkit-transition: background-color 0.5s ease-out;
  -moz-transition: background-color 0.5s ease-out;
  -o-transition: background-color 0.5s ease-out;
  transition: background-color 0.5s ease-out;
}
table th {
  text-align: left;
  background: #e47215;
  color: #fff;
  padding: 8px !important;
  border-radius: 5%;
}

table td {
  text-align: left;
  padding: 8px !important;
  font-size: 14px;
  border-right: 1px solid #e47215;
}
.table > tbody > tr > td,
.table > tfoot > tr > td,
.table > thead > tr > td {
  padding: 4px !important;
  line-height: 1.42857143;
  vertical-align: top;
  border-top: 1px solid #ddd;
}

table td:last-child {
  border-right: none;
}
table tbody tr:nth-child(n) td {
  background: white;
  height: 30px !important;
  -webkit-transition: background-color 1s ease-out;
  -moz-transition: background-color 1s ease-out;
  -o-transition: background-color 1s ease-out;
  transition: background-color 1s ease-out;
}

table tbody {
  overflow-y: auto;
  height: 100px;
  position: relative;
}

.new1 {
  cursor: pointer;
}

.new2 {
  cursor: pointer;
}
.text-mision {
  font-size: 16px;
  text-align: justify;
}
ul.padding {
  padding-left: 30px !important;
  padding-right: 60px !important;
}

.container--style {
  padding-left: 3% !important;
  padding-right: 3% !important;
  padding-bottom: 0% !important;
  width: 100% !important;
  background-color: #394049 !important;
}

.titlep {
  color: #ec6a12;
}

.v-card-new {
  margin-top: 50px;
  margin-bottom: 3%;
  margin-left: 3%;
  padding-right: 15px;
  padding-left: 15px;
  padding-top: 0.5%;
  background: #394049 !important;
  height: 343px !important;
  overflow-y: auto;
}

.v-card {
  height: 350px;
  overflow-y: auto;
}

.font {
  color: white !important;
}

.pull {
  text-align: justify;
}

.new-card {
  height: auto;
}

.v-list-new {
  height: 100% !important;
}

.v-btn__content {
  font-size: 10px !important;
}

.theme--light.v-btn {
  color: white;
}

.v-btn {
  font-size: 10px;
  border-radius: 50px;
}

p.bold {
  font-weight: bold;
  color: white;
}

.th {
  background-color: aqua !important;
}

/* width */
::-webkit-scrollbar {
  width: 3px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.image {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/definicionEstrategica/ODSFuturo.vue